import apiFetch from '../apiFetch'

export default function (token, faqSectionId) {
  return apiFetch({ endPoint: `FaqSection/${faqSectionId}`, method: 'DELETE', body: null, token: token })
}
